import { AdministrateResourceDeleteButton } from "../../../components/AdministrateResourceDeleteButton";
import { useTableContext } from "../../../components/AdministrateTable";
import { useDestroyPermission, useUpdatePermission } from "../../../utils";
import { History } from "../../sandbox/release/History";
import { EditQaCategory } from "./EditQaCategoryModal";

export const QaCategoryActionCell = ({ row }) => {
  const { refresh, setMessage, setError } = useTableContext();
  const [canDestroy] = useDestroyPermission("QaCategory", row.original.id);
  const [canUpdate] = useUpdatePermission("QaCategory", row.original.id);

  return (
    <>
      {canUpdate && (
        <EditQaCategory
          color="link"
          qaCategory={row.original}
          onUpdate={(row) => {
            refresh();
            setMessage(`Updated ${row.name} category.`);
          }}
        />
      )}

      {canDestroy && (
        <AdministrateResourceDeleteButton
          deleteUrl={`/admin/qa_categories/${row.original.id}`}
          onSuccess={() => {
            refresh();
            setMessage(`Deleted QA Category ${row.original.name}.`);
          }}
          onError={setError}
        />
      )}

      <History entityName="QaCategory" subjectId={row.original.id} />
    </>
  );
};
